import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Vehicule } from './shared-constants';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class UserVehiclesService {
	constructor(
		private db: SpaqFireDb,
		private auth: AngularFireAuth
	) {}

	hydrate() {
		return this.auth.user.pipe(switchMap(u => (u ? this.db.userVehicles$<Vehicule[]>(u.uid) : EMPTY)));
	}
}
